import { render, staticRenderFns } from "./ProjectAction.vue?vue&type=template&id=46fc436a&"
import script from "./ProjectAction.vue?vue&type=script&lang=js&"
export * from "./ProjectAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports